export const HERO_WEBEX_URL = 'https://eurl.io/#PXrpeYNX0';
export const RESET_TRANSITION_TIME = 200;
export const TRANSITION_TIME = 5000;
